module.exports = __webpack_public_path__ + "img/背景@2x.8cb74a9c.png";